<script lang="ts" setup>
import OneNewsOrPromotion from '~/widgets/newsOrPromotions/OneNewsOrPromotion.vue';
import ProductsSection from '~/widgets/brands/brand/ProductsSection.vue';
import BrandCompilation from '~/widgets/brands/brand/BrandCompilation.vue';
import type { OneNewsDataOrPromotion } from "~/shared/interfaces/OneNewsDataOrPromotion"
import type { IBreadcrumbs } from "~/shared/interfaces/ui/breadcrumbs";

definePageMeta({ layout: "static" });

const route = useRoute();
const slug = route.params.slug as string;

const newsData = ref<OneNewsDataOrPromotion>();
const breadcrumbsList = ref<IBreadcrumbs[]>([]);

async function getOneNewsData() {
  if (!newsData.value) {
    const { data} = await useFetch<OneNewsDataOrPromotion>(`/api/news/getOneNews/${slug}`);

    if(data.value) {
      newsData.value = data.value
      breadcrumbsList.value = [
        { name: "Новости компании", slug: "news" },
        { name: newsData.value.title }
      ]
    }
    else {
      throw createError({ statusCode: 404, statusMessage: 'Page Not Found', fatal: true });
    }
  }
}

await getOneNewsData();
</script>

<template>
  <section v-if="newsData" class="news-detail">
    <OneNewsOrPromotion 
      :dataOneNewsOrPromotion="newsData" 
      :breadcrumbsList="breadcrumbsList" 
    />
    <ProductsSection 
      v-if="newsData.products?.length" 
      section-title="Товары из новости" 
      :products="newsData.products"
      :is-card-without-button="false" 
      :quantityForSlider="4" 
    />

    <div v-if="newsData.brandCompilations?.length" class="news-detail__brandCompilation">
      <BrandCompilation :items="newsData.brandCompilations" />
    </div>
  </section>
</template>

<style lang="scss" scoped>
.news-detail {
  &__brandCompilation {
    margin: 40px 0px 28px;

    @include sm-breakpoint {
      margin: 28px 0px 28px;
    }
  }
}
</style>
